import { useQuery, UseQueryResult } from 'react-query';

import { PaginatedList, BlackListDto, BlackListFilterOptions } from '../../types';
import blackListApiService from '../../services/api/black-list/black-list.api.service';

export const useBlackListData = (
  filterOptions: BlackListFilterOptions,
): UseQueryResult<PaginatedList<BlackListDto>, unknown> =>
  useQuery(['black-list', filterOptions], () => blackListApiService.get(filterOptions));
